import React, { forwardRef } from 'react';
import './SharedSearchInput.css';

/**
 * A highly reusable search input component with Apple-aesthetic design.
 * Features a built-in SVG magnifying glass icon and a clear button.
 * 
 * @param {Object} props
 * @param {string} props.value - The current search value.
 * @param {function} props.onChange - Callback when input changes (passes the event).
 * @param {string} props.placeholder - Placeholder text.
 * @param {function} [props.onClear] - Optional callback when the clear button is clicked. If not provided, clear button is hidden.
 * @param {string} [props.className] - Additional classes for the wrapper.
 * @param {Object} [props.style] - Additional styles for the wrapper.
 */
const SharedSearchInput = forwardRef(({ 
    value, 
    onChange, 
    placeholder = "Suchen...", 
    onClear,
    className = "",
    style = {}
}, ref) => {
    return (
        <div className={`shared-search-wrapper ${className}`} style={style}>
            <input 
                ref={ref}
                type="text" 
                className="shared-search-input"
                placeholder={placeholder} 
                value={value} 
                onChange={onChange}
            />
            {value && onClear && (
                <button 
                    type="button" 
                    className="shared-search-clear" 
                    onClick={onClear}
                    title="Suche leeren"
                >
                    ✕
                </button>
            )}
        </div>
    );
});

export default SharedSearchInput;
